<div class="no-results">
  <svg
    class="no-results__icon"
    width="90"
    height="90"
    viewBox="0 0 90 90"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M41.25 71.25C57.8185 71.25 71.25 57.8185 71.25 41.25C71.25 24.6815 57.8185 11.25 41.25 11.25C24.6815 11.25 11.25 24.6815 11.25 41.25C11.25 57.8185 24.6815 71.25 41.25 71.25Z"
      stroke="#7D9098"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M78.75 78.75L62.4375 62.4375"
      stroke="#7D9098"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>

  <span class="no-results__text">Sorry, no results found</span>
</div>
